import React from 'react';
import {PlanRow} from '../CreateBuilder/BuilderSourceDestination/PlanRow';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {PlanValidationIcon} from '../CreateBuilder/BuilderSourceDestination/PlanValidationIcon';
import {usePlanValidationLevel} from '../CreateBuilder/BuilderSourceDestination/usePlanValidationLevel';
import {
  BankAccountRowStatus,
  BankAccountRowSummary,
} from '../CreateBuilder/BuilderSourceDestination/BankAccountRowSummary';
import {BankAccountDetails} from '../CreateBuilder/BuilderSourceDestination/BankAccountDetails';
import {WithdrawalDestinationAccount} from './useWithdrawalPotsQuery';

interface WithdrawalDestinationBankAccountProps {
  bankAccount: WithdrawalDestinationAccount;
  isSelected: boolean;
  handleChange: (bankAccountId: string) => void;
}

export const WithdrawalDestinationBankAccount: React.FC<
  WithdrawalDestinationBankAccountProps
> = ({bankAccount, isSelected, handleChange}) => {
  const formikKeyPrefix = isSelected ? 'withdraw.destination' : undefined;
  const {bgClass} = usePlanValidationLevel(formikKeyPrefix);

  return (
    <PlanRow
      id={bankAccount.id}
      reccId={null}
      curoId={bankAccount.curoId ?? undefined}
      isSelected={isSelected}
      isSubplan={false}
    >
      <PlanAccordionShell
        expanded={isSelected}
        isSelected={isSelected}
        isSoleParent
        validationLevel={bgClass}
        summaryChildren={
          <BankAccountRowSummary
            bankAccount={bankAccount}
            isSelected={isSelected}
            handleChange={() => handleChange(bankAccount.id)}
          />
        }
        summaryTrailing={
          <>
            <BankAccountRowStatus bankAccount={bankAccount} />
            {formikKeyPrefix && <PlanValidationIcon formikKeyPrefix={formikKeyPrefix} />}
          </>
        }
      >
        <BankAccountDetails bankAccount={bankAccount} />
      </PlanAccordionShell>
    </PlanRow>
  );
};
